import axios, { AxiosPromise } from 'axios';
import { Ciclo, Plano } from '@/utils/planos';

export type Cobranca = { id: string; value: number; dueDate: string; status: string; invoiceUrl?: string };
export type Assinatura = { plano?: Plano; ciclo?: Ciclo; valor?: number; situacao: string; testeAte?: string; pagoAte?: string;
  acessoCompleto: boolean; ativa: boolean; cobrancas: Cobranca[] };

export const consultar = (): AxiosPromise<Assinatura> => axios.get('/api/assinatura');
export const ativar = (dados: { cpfCnpj: string; nome: string; email: string; plano: Plano; ciclo: Ciclo }): AxiosPromise<{ invoiceUrl?: string | null }> =>
  axios.post('/api/assinatura', dados);
export const trocarPlano = (plano: Plano, ciclo: Ciclo): AxiosPromise<void> => axios.put('/api/assinatura/plano', { plano, ciclo });
export const cancelar = (): AxiosPromise<void> => axios.delete('/api/assinatura');
